/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The protocol to use for the swap/order.
 */
export enum ProtocolItems {
    V2 = 'V2',
    V3 = 'V3',
    V4 = 'V4',
    FEW_V2 = 'FewV2',
    UNISWAPX = 'UNISWAPX',
    UNISWAPX_V2 = 'UNISWAPX_V2',
    UNISWAPX_V3 = 'UNISWAPX_V3',
}
